(function() {
    'use strict';

    angular.module('remitEventsApp').controller('ProductionUnitDialogController', [
        '$scope',
        '$uibModalInstance',
        'entity',
        'ProductionUnit',
        function($scope, $uibModalInstance, entity, ProductionUnit) {
            $scope.productionUnit = entity;
            $scope.load = function(id) {
                ProductionUnit.get({ id: id }, function(result) {
                    $scope.productionUnit = result;
                });
            };

            var onSaveFinished = function(result) {
                $scope.$emit('remitEventsApp:productionUnitUpdate', result);
                $uibModalInstance.close(result);
            };

            $scope.save = function() {
                if ($scope.productionUnit.id != null) {
                    ProductionUnit.update($scope.productionUnit, onSaveFinished);
                } else {
                    ProductionUnit.save($scope.productionUnit, onSaveFinished);
                }
            };

            $scope.clear = function() {
                $uibModalInstance.dismiss('cancel');
            };
        }
    ]);
})();
